<template>
  <field
    :empty="isEmpty && !forceLabelToTop && !placeholder"
    v-bind="$attrs"
    :label="label"
    :hide-label="hideLabel"
    :unstyled="true"
    class="text-left"
  >
    <div v-bind="{ ...$attrs, class: '' }" class="editor">
      <QuillEditor
        v-model:content="internalValue"
        content-type="html"
        :placeholder="placeholder"
        :aria-label="label"
      />
    </div>
  </field>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import Field from '@components/utils/inputs/Field.vue';
import {computed, watch, unref} from 'vue';
import { QuillEditor } from '@vueup/vue-quill';

interface Props {
  modelValue?: string | number;
  label?: string;
  placeholder?: string;
  forceLabelToTop?: boolean;
  hideLabel?: boolean;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const internalValue = useVModel(props, 'modelValue', emit, { passive: true });

if (unref(props.modelValue) === undefined) {
  internalValue.value = '';
}

const isEmpty = computed(() => !internalValue.value);
</script>
<style lang="scss" scoped>
.editor {
  background-color: var(--input-bg, var(--color-background-light));

  :deep(.ql-editor) {
    min-height: 10rem;
  }

  :deep(p) {
    margin-bottom: 0.75rem;
  }

  :deep(h1) {
    font-size: 1.88rem;
    margin-bottom: 0.75rem;
  }

  :deep(h2) {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  :deep(h3) {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }

  :deep(ol), :deep(ul) {
    padding-bottom: 1.5em;
  }
}
</style>
